import { useMutation, useQueryClient } from "@tanstack/vue-query";
import User from "@/services/user";
import type { RegisterUser } from "@/dtos/User.dto";
import { invalidateBillingQueriesWithDelay } from "@/composables/billing";

export interface RegisterUserPayload extends RegisterUser {
  phoneNumber?: string;
  jobTitle?: string;
}

export function useRegisterUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RegisterUserPayload) => {
      const result = await User.registerUser(payload);
      if (result?.data?.status) {
        return result.data.data;
      }
      throw new Error(result?.data?.msg || "Failed to invite user");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      invalidateBillingQueriesWithDelay(queryClient);
    },
  });
}
